export class InternationalRoadShipmentGoodAdr {
    public id:number|null;
    public international_road_shipment_good_id:number|null;
    public shipment_goods_seq:number|null;
    public un_number:string|null;
    public description:string|null;
    public classification:string|null;
    public transport_category:string|null;
    public labels:string|null;
    public trc:string|null;
    public packing_group:string|null;
    public quantity:number|null;
    public package_code:string|null;
    public package_id:number|null;
    public weight:number|null;
    public nos_origin_language:string|null;
    public nos_en_fr_de:string|null;
    public environmentally_hazardous:boolean;
    public marine_pollutant:boolean;

    constructor(data:InternationalRoadShipmentGoodAdrData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.international_road_shipment_good_id = null;
            this.shipment_goods_seq = null;
            this.un_number = "";
            this.description = "";
            this.classification = "";
            this.transport_category = "";
            this.labels = "";
            this.trc = "";
            this.packing_group = "";
            this.quantity = null;
            this.package_code = "";
            this.package_id = null;
            this.weight = null;
            this.nos_origin_language = null;
            this.nos_en_fr_de = null;
            this.environmentally_hazardous = false;
            this.marine_pollutant = false;
        }
        else
        {
            this.id = data.id;
            this.international_road_shipment_good_id = data.international_road_shipment_good_id;
            this.shipment_goods_seq = data.shipment_goods_seq;
            this.un_number = data.un_number;
            this.description = data.description;
            this.classification = data.classification;
            this.transport_category = data.transport_category;
            this.labels = data.labels;
            this.trc = data.trc;
            this.packing_group = data.packing_group;
            this.quantity = data.quantity;
            this.package_code = data.package_code;
            this.package_id = data.package_id;
            this.weight = data.weight;
            this.nos_origin_language = data.nos_origin_language;
            this.nos_en_fr_de = data.nos_en_fr_de;
            this.environmentally_hazardous = data.environmentally_hazardous;
            this.marine_pollutant = data.marine_pollutant;
        }
    }

    serializeData():InternationalRoadShipmentGoodAdrData {
        return {
            id: this.id,
            international_road_shipment_good_id: this.international_road_shipment_good_id,
            shipment_goods_seq: this.shipment_goods_seq,
            un_number: this.un_number,
            description: this.description,
            classification: this.classification,
            transport_category: this.transport_category,
            labels: this.labels,
            trc: this.trc,
            packing_group: this.packing_group,
            quantity: this.quantity,
            package_code: this.package_code,
            package_id: this.package_id,
            weight: this.weight,
            nos_origin_language: this.nos_origin_language,
            nos_en_fr_de: this.nos_en_fr_de,
            environmentally_hazardous: this.environmentally_hazardous,
            marine_pollutant: this.marine_pollutant,
        }
    }
}

export type InternationalRoadShipmentGoodAdrData = {
    id:number|null;
    international_road_shipment_good_id:number|null;
    shipment_goods_seq:number|null;
    un_number:string|null;
    description:string|null;
    classification:string|null;
    transport_category:string|null;
    labels:string|null;
    trc:string|null;
    packing_group:string|null;
    quantity:number|null;
    package_code:string|null;
    package_id:number|null;
    weight:number|null;
    nos_origin_language:string|null;
    nos_en_fr_de:string|null;
    environmentally_hazardous:boolean;
    marine_pollutant:boolean;
}
